import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import PhotoBoothShowcase from "./components/PhotoBoothShowcase";
import Features from "./components/Features";
import FunGallery from "./components/FunGallery";
import Pricing from "./components/Pricing";
import ContactForm from "./components/ContactForm";
import SocialMedia from "./components/SocialMedia";
import Footer from "./components/Footer";

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <PhotoBoothShowcase />
        <FunGallery />
        <Features />
        <Pricing />
        <ContactForm />
        <SocialMedia />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
